import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SettingsProvider } from "@/lib/settings";

import PublicLayout from "@/components/PublicLayout";
import RedirectHandler from "@/components/RedirectHandler";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import CoursesPage from "@/pages/CoursesPage";
import CourseDetailPage from "@/pages/CourseDetailPage";
import ServicesPage from "@/pages/ServicesPage";
import PartnerWithUsPage from "@/pages/PartnerWithUsPage";
import BlogPage from "@/pages/BlogPage";
import BlogDetailPage from "@/pages/BlogDetailPage";
import GalleryPage from "@/pages/GalleryPage";
import ContactPage from "@/pages/ContactPage";
import TrainersPage from "@/pages/TrainersPage";
import { CorporatePage, InternshipPage, PlacementPage, CertificationPage, CareersPage } from "@/pages/InfoPages";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import { PrivacyPage, TermsPage } from "@/pages/SimplePages";

import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import { AdminCourses, AdminBlogs, AdminTestimonials, AdminFAQs, AdminGallery, AdminEvents, AdminTrainers, AdminSlides } from "@/pages/admin/AdminContent";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminWhatsApp from "@/pages/admin/AdminWhatsApp";
import AdminChatbot from "@/pages/admin/AdminChatbot";
import AdminBranding from "@/pages/admin/AdminBranding";
import AdminRedirects from "@/pages/admin/AdminRedirects";
import AdminInstagram from "@/pages/admin/AdminInstagram";
import AdminBlogsList from "@/pages/admin/AdminBlogsList";
import AdminBlogEditor from "@/pages/admin/AdminBlogEditor";
import AdminAbout from "@/pages/admin/AdminAbout";
import AdminServices from "@/pages/admin/AdminServices";
import AdminPartner from "@/pages/admin/AdminPartner";
import AdminPartnerLeads from "@/pages/admin/AdminPartnerLeads";
import AdminMenu from "@/pages/admin/AdminMenu";

import "@/App.css";

export default function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
        <RedirectHandler />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/courses/:slug" element={<CourseDetailPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/partner-with-us" element={<PartnerWithUsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/trainers" element={<TrainersPage />} />
            <Route path="/corporate-training" element={<CorporatePage />} />
            <Route path="/internship" element={<InternshipPage />} />
            <Route path="/placement" element={<PlacementPage />} />
            <Route path="/certification" element={<CertificationPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Route>

          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="about" element={<AdminAbout />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="partner" element={<AdminPartner />} />
            <Route path="partner-leads" element={<AdminPartnerLeads />} />
            <Route path="menu" element={<AdminMenu />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="newsletter" element={<AdminNewsletter />} />
            <Route path="courses" element={<AdminCourses />} />
            <Route path="slides" element={<AdminSlides />} />
            <Route path="trainers" element={<AdminTrainers />} />
            <Route path="blogs" element={<AdminBlogsList />} />
            <Route path="blogs/:id" element={<AdminBlogEditor />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="faqs" element={<AdminFAQs />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="instagram" element={<AdminInstagram />} />
            <Route path="whatsapp" element={<AdminWhatsApp />} />
            <Route path="chatbot" element={<AdminChatbot />} />
            <Route path="redirects" element={<AdminRedirects />} />
            <Route path="branding" element={<AdminBranding />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </SettingsProvider>
  );
}
